import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/fuli-mobile.png';
import _imports_1 from '@/assets/img/fuli.png';
const _withScopeId = n => (_pushScopeId("data-v-586743da"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "dialog-mask"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tips" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "tip" }, "单笔首次充值100元，可用余额立即增至200元！"),
    /*#__PURE__*/ _createElementVNode("div", { class: "tip" }, "返现金额无门槛，所有服务均可抵扣。")
], -1));
const _hoisted_3 = {
    key: 0,
    src: _imports_0,
    class: "img",
    alt: ""
};
const _hoisted_4 = {
    key: 1,
    src: _imports_1,
    class: "img",
    alt: ""
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "btn_text" }, "立即充值", -1));
const _hoisted_6 = { class: "display-flex align-items countdown" };
const _hoisted_7 = /*#__PURE__*/ _createTextVNode("倒计时 ");
const _hoisted_8 = {
    key: 2,
    class: "text"
};
import { onClickOutside } from "@vueuse/core";
import countdown from "./countdown.vue";
import { onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { popupStatus } from "@/service/user";
import { getUserInfo } from "@/utils/auth";
import { isMobileDevice } from "@/utils";
export default /*#__PURE__*/ _defineComponent({
    name: 'newUserDialog',
    setup(__props) {
        const visible = ref(false);
        const handleClose = () => {
            visible.value = false;
        };
        const target = ref(null);
        onClickOutside(target, () => {
            handleClose();
        });
        const router = useRouter();
        const doNotRemind = ref(true);
        const time = ref(0);
        const popupShow = ref(false);
        const todayDate = new Date().toISOString().slice(0, 10);
        const remindKey = `noRemindUserDate_${getUserInfo().user_id}`;
        const getStatus = async () => {
            const { data } = await popupStatus();
            time.value = data.welfare_2_countdown;
            popupShow.value = data.welfare_2_popup;
        };
        // 判断是否今天已勾选“不再提醒”
        const hasNoRemindToday = localStorage.getItem(remindKey) === todayDate;
        // 页面挂载时判断是否需要弹窗
        onMounted(async () => {
            if (localStorage.getItem("loginState") !== "already") {
                return;
            }
            await getStatus();
            if (popupShow.value &&
                !hasNoRemindToday &&
                localStorage.getItem("loginState") === "already") {
                localStorage.setItem(remindKey, todayDate);
                visible.value = true;
            }
        });
        watch(doNotRemind, (val) => {
            if (val) {
                localStorage.setItem(remindKey, todayDate);
            }
            else {
                localStorage.removeItem(remindKey);
            }
        });
        const goRecharge = () => {
            visible.value = false;
            if (isMobileDevice()) {
                router.push("/personal/recharge");
                return;
            }
            router.push("/finance/recharge");
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            const _component_el_checkbox = _resolveComponent("el-checkbox");
            return (visible.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", {
                        ref_key: "target",
                        ref: target,
                        class: _normalizeClass(_unref(isMobileDevice)() ? 'mobile dialog-container' : 'dialog-container')
                    }, [
                        _createElementVNode("div", {
                            class: "close-box display-flex align-items",
                            onClick: handleClose
                        }, [
                            _createVNode(_component_svg_icon, {
                                "icon-class": "close1",
                                class: "close-icon"
                            })
                        ]),
                        _hoisted_2,
                        (_unref(isMobileDevice)())
                            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                            : (_openBlock(), _createElementBlock("img", _hoisted_4)),
                        _createElementVNode("div", {
                            class: "recharge_btn",
                            onClick: goRecharge
                        }, [
                            _hoisted_5,
                            _createElementVNode("span", _hoisted_6, [
                                _hoisted_7,
                                _createVNode(countdown, {
                                    seconds: time.value,
                                    class: "m-l-8 display-flex"
                                }, null, 8, ["seconds"])
                            ])
                        ]),
                        (_unref(isMobileDevice)())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 最终活动解释权归英博数科有限公司所有 "))
                            : _createCommentVNode("", true),
                        _createVNode(_component_el_checkbox, {
                            modelValue: doNotRemind.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((doNotRemind).value = $event)),
                            class: "no_mind",
                            label: "今日不再提醒 ",
                            size: "large"
                        }, null, 8, ["modelValue"])
                    ], 2)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
